module.exports = __webpack_public_path__ + "img/logo-login.dc7682a5.png";